import { render } from "./VOCLogo.vue?vue&type=template&id=350ad9f8&scoped=true"
import script from "./VOCLogo.vue?vue&type=script&lang=js"
export * from "./VOCLogo.vue?vue&type=script&lang=js"

import "./VOCLogo.vue?vue&type=style&index=0&id=350ad9f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350ad9f8"]])

export default __exports__